import { Component, EventEmitter, Injector, Input, OnInit, Output } from '@angular/core';
import { AppComponentBase } from '@shared/app-component-base';
import { UserServiceProxy, WarehouseDto, WarehouseServiceProxy } from '@shared/service-proxies/service-proxies';

@Component({
  selector: 'app-select-warehouse',
  templateUrl: './select-warehouse.component.html',
  styleUrls: ['./select-warehouse.component.css']
})

export class SelectWarehouseComponent extends AppComponentBase implements OnInit {

  dataSource: WarehouseDto[] = [];
  isDisabled: boolean = false;

  @Input()
  showAll: boolean = true;

  @Input()
  manuelDisabled: boolean = null;

  @Input()
  placeholder: string = this.l('Warehouse');

  private _companyId: number = 0;
  @Input()
  set companyId(value: number) {
    if (this._companyId === value) {
      return;
    }
    this._companyId = value;
    this.loadWarehouseList();
  }

  private _selection: number = 0;
  get selection(): number {
    return this._selection;
  }
  @Input()
  set selection(value: number) {
    if (this._selection === value) {
      return;
    }
    this._selection = value;
    this.selectionChange.emit(this._selection);
  }
  // @Input() selection: number;
  @Output() selectionChange = new EventEmitter<number>();

  constructor(injector: Injector,
    private _warehouseService: WarehouseServiceProxy,
    private _userService: UserServiceProxy) {
    super(injector);
  }

  ngOnInit(): void {
    this.loadWarehouseList();

    this._userService.get(abp.session.userId).subscribe(result => {
      this.isDisabled = !result.isChangeWarehouse;
      if (this.manuelDisabled != null)
        this.isDisabled = this.manuelDisabled;
      if (!result.isChangeWarehouse) {
        this.selection = result.warehouseId;
      }
    });
  }

  onSelectionChnaged() {
    this.selectionChange.emit(this.selection);
  }

  private loadWarehouseList(){
    this._warehouseService.getWarehouseList(this._companyId)
      .subscribe((result) => {
        this.dataSource = result;
      });
  }
}
